import helpers from '../../helpers'

export default {
  'entityName': 'siteresponse_has_drug',
  'title': 'Drug serial numbers',
  id: ['siterequest_id', 'drug_id', 'lotto'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'descending': true
  },
  'fields': [
    {
      value: 'drug_id',
      type: 'hidden'
    },
    {
      value: '_drug_id',
      id: 'drug_id',
      text: 'Drug',
      table: true,
      render: ({ drug }) => !drug ? '' : drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      readonly: true
    },
    {
      value: 'lotto',
      text: 'Batch number',
      table: true,
      readonly: true,
      mini: true
  },
  {
      "value": "expiration",
      mini: true,
      "text": "Expiration",
      table: true,
      readonly: true
  },
  {
    "value": "n_pieces",
    "text": "Quantity",
    mini: true,
    table: {
      sortable: true
    },
    readonly: true
  },
  {
      full: true,
      "value": "_serials",
      "text": "Serial numbers",
      deps: ['lotto'],
      default: item => item.serials,
      "type": "textarea",
      "validators": [
          "required",
          "serials",
          (field, value, item) => helpers.nSerials(value)<=item.n_pieces || `N. serials should be <= of ${item.n_pieces}`
      ]
    },
    {
      value: 'serials',
      type: 'hidden',
      text: 'Serial numbers',
      table: true,
      render: item => item.serials && `${item.serials.replaceAll(',', ', ')}`,
      deps: ['_serials'],
      default: item => {
        return item._serials && helpers.compatSerials(helpers.explodeSerials(item._serials))
      }
    },
  ],
  actions: []
}
